import { render } from "./NumberCard.vue?vue&type=template&id=098b0b10&scoped=true"
import script from "./NumberCard.vue?vue&type=script&lang=js"
export * from "./NumberCard.vue?vue&type=script&lang=js"

import "./NumberCard.vue?vue&type=style&index=0&id=098b0b10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-098b0b10"]])

export default __exports__